import React, { Component } from "react";

import readingTime from "reading-time";

import { MuiThemeProvider } from "@material-ui/core/styles";

import { CssBaseline, Button, Snackbar } from "@material-ui/core";

import { auth, firestore, functions } from "../../firebase";
import authentication from "../../services/authentication";
import appearance from "../../services/appearance";

import ErrorBoundary from "../ErrorBoundary";
import LaunchScreen from "../LaunchScreen";
import Bar from "../Bar";
import MiniDrawer from "../Bar/VBar";
import Router from "../Router";
import DialogHost from "../DialogHost";
// import MuiAlert from '@material-ui/lab/Alert';
import Alert from '@material-ui/lab/Alert';
import NetworkDetector from "./NetworkDetector";

// function Alert(props) {
//   return <MuiAlert elevation={6} variant="filled" {...props} />;
// }

const initialState = {
  ready: false,
  performingAction: false,
  theme: appearance.defaultTheme,
  user: null,
  userData: null,
  roles: [],
  appSettings: null,
  aboutDialog: {
    open: false,
  },

  signUpDialog: {
    open: false,
  },

  signInDialog: {
    open: false,
  },

  settingsDialog: {
    open: false,
  },

  deleteAccountDialog: {
    open: false,
  },

  signOutDialog: {
    open: false,
  },

  snackbar: {
    autoHideDuration: 0,
    message: "",
    open: false,
    vertical: 'top',
    horizontal: 'center',
    severity: 'info'
  },
};

class App extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  resetState = (callback) => {
    this.setState(
      {
        ready: true,
        theme: appearance.defaultTheme,
        user: null,
        userData: null,
        appSettings: null,
        roles: [],
      },
      callback
    );
  };

  setTheme = (theme, callback) => {
    if (!theme) {
      this.setState(
        {
          theme: appearance.defaultTheme,
        },
        callback
      );

      return;
    }

    this.setState(
      {
        theme: appearance.createTheme(theme),
      },
      callback
    );
  };

  openDialog = (dialogId, callback) => {
    const dialog = this.state[dialogId];

    if (!dialog || dialog.open === undefined || null) {
      return;
    }

    dialog.open = true;

    this.setState({ dialog }, callback);
  };

  closeDialog = (dialogId, callback) => {
    const dialog = this.state[dialogId];

    if (!dialog || dialog.open === undefined || null) {
      return;
    }

    dialog.open = false;

    this.setState({ dialog }, callback);
  };

  closeAllDialogs = (callback) => {
    this.setState(
      {
        aboutDialog: {
          open: false,
        },

        signUpDialog: {
          open: false,
        },

        signInDialog: {
          open: false,
        },

        settingsDialog: {
          open: false,
        },

        deleteAccountDialog: {
          open: false,
        },

        signOutDialog: {
          open: false,
        },
      },
      callback
    );
  };

  deleteAccount = () => {
    this.setState(
      {
        performingAction: true,
      },
      () => {
        authentication
          .deleteAccount()
          .then(() => {
            this.closeAllDialogs(() => {
              this.openSnackbar("Deleted account", 'success');
            });
          })
          .catch((reason) => {
            const code = reason.code;
            const message = reason.message;

            switch (code) {
              default:
                this.openSnackbar(message, 'error');
                return;
            }
          })
          .finally(() => {
            this.setState({
              performingAction: false,
            });
          });
      }
    );
  };

  signOut = () => {
    this.setState(
      {
        performingAction: true,
      },
      () => {
        authentication
          .signOut()
          .then(() => {
            this.closeAllDialogs(() => {
              this.openSnackbar("Signed out", 'success');
            });
          })
          .catch((reason) => {
            const code = reason.code;
            const message = reason.message;

            switch (code) {
              default:
                this.openSnackbar(message, 'error');
                return;
            }
          })
          .finally(() => {
            this.setState({
              performingAction: false,
            });
          });
      }
    );
  };

  openSnackbar = (message, severity='info', autoHideDuration = 2, vertical='top', horizontal='center', callback) => {
    // debugger
    this.setState(
      {
        snackbar: {
          autoHideDuration: readingTime(message).time * autoHideDuration,
          message: message,
          open: true,
          vertical: vertical,
          horizontal: horizontal,
          severity: severity
        },
      },
      () => {
        if (callback && typeof callback === "function") {
          callback();
        }
      }
    );
  };

  closeSnackbar = (clearMessage = false) => {
    const { snackbar } = this.state;

    this.setState({
      snackbar: {
        message: clearMessage ? "" : snackbar.message,
        open: false,
        vertical: 'top',
        horizontal: 'center',
        severity: 'info'
      },
    });
  };

  render() {
    const {
      ready,
      performingAction,
      theme,
      user,
      userData,
      appSettings,
      roles,
    } = this.state;

    const {
      aboutDialog,
      signUpDialog,
      signInDialog,
      settingsDialog,
      deleteAccountDialog,
      signOutDialog,
    } = this.state;

    const { snackbar } = this.state;

    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />

        <ErrorBoundary>
          {!ready && <LaunchScreen />}

          {ready && (
            <>
              <Router
                user={user}
                roles={roles}
                theme={theme}
                // bar={
                //   // <>
                //   // <MiniDrawer />
                //   <MiniDrawer
                //     performingAction={performingAction}
                //     theme={theme}
                //     user={user}
                //     userData={userData}
                //     roles={roles}
                //     onSignUpClick={() => this.openDialog("signUpDialog")}
                //     onSignInClick={() => this.openDialog("signInDialog")}
                //     onAboutClick={() => this.openDialog("aboutDialog")}
                //     onSettingsClick={() => this.openDialog("settingsDialog")}
                //     onSignOutClick={() => this.openDialog("signOutDialog")}
                //   />
                //   // </>
                // }
                openSnackbar={this.openSnackbar}
                openDialog={this.openDialog}
                signOutCall={this.signOut}
                performingAction={performingAction}
                userData={userData}
                appSettings={appSettings}
              />

              <DialogHost
                performingAction={performingAction}
                theme={theme}
                user={user}
                userData={userData}
                appSettings={appSettings}
                openSnackbar={this.openSnackbar}
                dialogs={{
                  aboutDialog: {
                    dialogProps: {
                      open: aboutDialog.open,

                      onClose: () => this.closeDialog("aboutDialog"),
                    },
                  },

                  signUpDialog: {
                    dialogProps: {
                      open: signUpDialog.open,

                      onClose: (callback) => {
                        this.closeDialog("signUpDialog");

                        if (callback && typeof callback === "function") {
                          callback();
                        }
                      },
                    },
                  },

                  signInDialog: {
                    dialogProps: {
                      open: signInDialog.open,

                      onClose: (callback) => {
                        this.closeDialog("signInDialog");

                        if (callback && typeof callback === "function") {
                          callback();
                        }
                      },
                    },
                  },

                  settingsDialog: {
                    dialogProps: {
                      open: settingsDialog.open,

                      onClose: () => this.closeDialog("settingsDialog"),
                    },

                    props: {
                      onDeleteAccountClick: () =>
                        this.openDialog("deleteAccountDialog"),
                    },
                  },

                  deleteAccountDialog: {
                    dialogProps: {
                      open: deleteAccountDialog.open,

                      onClose: () => this.closeDialog("deleteAccountDialog"),
                    },

                    props: {
                      deleteAccount: this.deleteAccount,
                    },
                  },

                  signOutDialog: {
                    dialogProps: {
                      open: signOutDialog.open,

                      onClose: () => this.closeDialog("signOutDialog"),
                    },

                    props: {
                      title: "Log out?",
                      contentText:
                        "While logged out you are unable to manage your profile and conduct other activities that require you to be logged in.",
                      dismissiveAction: (
                        <Button
                          color="primary"
                          onClick={() => this.closeDialog("signOutDialog")}
                        >
                          Cancel
                        </Button>
                      ),
                      confirmingAction: (
                        <Button
                          color="primary"
                          disabled={performingAction}
                          variant="contained"
                          onClick={this.signOut}
                        >
                          Log Out
                        </Button>
                      ),
                    },
                  },
                }}
              />

              <Snackbar
                autoHideDuration={snackbar.autoHideDuration}
                message={snackbar.message}
                open={snackbar.open}
                onClose={this.closeSnackbar}
                anchorOrigin= {{vertical: snackbar.vertical, horizontal: snackbar.horizontal}}
              >
                <Alert onClose={this.closeSnackbar} severity={snackbar.severity}>
                  {snackbar.message}
                </Alert>
              </Snackbar>
            </>
          )}
        </ErrorBoundary>
      </MuiThemeProvider>
    );
  }

  componentDidMount() {
    this.onAuthStateChangedObserver = auth.onAuthStateChanged(
      async(user) => {
        /*debugger
         auth.currentUser.getIdToken(true).then((token)=>{
          debugger
          console.log(token)
        })*/
        // The user is not signed in or doesn’t have a user ID.
        if (!user || !user.uid) {
          if (this.userDocumentSnapshotListener) {
            this.userDocumentSnapshotListener();
          }

          this.resetState();

          return;
        }

        // The user is signed in, begin retrieval of external user data.
        this.userDocumentSnapshotListener = firestore
          .collection("users")
          .doc(user.uid)
          .onSnapshot(
            (snapshot) => {
              const data = snapshot.data();

              // The user doesn’t have a data point, equivalent to not signed in.
              if (!snapshot.exists || !data) {
                if (this.userDocumentSnapshotListener) {
                  this.userDocumentSnapshotListener();
                }

                this.resetState();

                return;
              }

              authentication
                .getRoles()
                .then((value) => {
                  this.setTheme(data.theme, () => {
                    if(data.roles.includes('VENDOR')) {
                      firestore.collection('stores').where('users', 'array-contains', snapshot.id)
                      .get().then(
                        (storeSnapshot) => {
                          let store = {};
                          storeSnapshot.docs.forEach((post) => {
                            const id = post.id;
                            const data = post.data();
                            store = { id, ...data }
                          });
                          this.setState({
                            ready: true,
                            user: user,
                            userData: {id: snapshot.id, storeId: store.id, store: store, ... data},
                            roles: value || [],
                          });
                          return store
                        })
                        .catch((error) => {
                          this.resetState(() => {
                            const code = error.code;
                            const message = error.message;

                            switch (code) {
                              default:
                                console.log(message)
                                this.openSnackbar(message, 'error');
                                return;
                            }
                          });
                        }
                      );
                    } else {
                      this.setState({
                        ready: true,
                        user: user,
                        userData: {id: snapshot.id, ... data},
                        roles: value || [],
                      });
                    }
                    
                    
                  });
                })
                .catch((reason) => {
                  this.resetState(() => {
                    const code = reason.code;
                    const message = reason.message;

                    switch (code) {
                      default:
                        this.openSnackbar(message, 'error');
                        return;
                    }
                  });
                });
            },
            (error) => {
              this.resetState(() => {
                const code = error.code;
                const message = error.message;

                switch (code) {
                  default:
                    this.openSnackbar(message, 'error');
                    return;
                }
              });
            }
          );

          // The user is signed in, begin retrieval of external config data.
          this.settingsSnapshotListener = firestore
          .collection("configs")
          // .doc("settings")
          .onSnapshot(
            (snapshot) => {
              // const data = snapshot.data();

              let data = {};
              snapshot.forEach(function (doc) {
                  const id = doc.id;
                  let settingValue = doc.data()
                  data[doc.id] = settingValue.value
              });

              // The settings doesn’t have a data point, equivalent to not signed in.
              // if (!snapshot.exists || !data) {
              //   if (this.settingsSnapshotListener) {
              //     this.settingsSnapshotListener();
              //   }

              //   this.resetState();

              //   return;
              // }
              this.setState({appSettings: data});
            },
            (error) => {
              this.resetState(() => {
                const code = error.code;
                const message = error.message;

                switch (code) {
                  default:
                    this.openSnackbar(message, 'error');
                    return;
                }
              });
            }
          );
      },
      (error) => {
        this.resetState(() => {
          const code = error.code;
          const message = error.message;

          switch (code) {
            default:
              this.openSnackbar(message, 'error');
              return;
          }
        });
      }
    );
  }

  componentWillUnmount() {
    if (this.onAuthStateChangedObserver) {
      this.onAuthStateChangedObserver();
    }

    if (this.userDocumentSnapshotListener) {
      this.userDocumentSnapshotListener();
    }

    if (this.settingsSnapshotListener) {
      this.settingsSnapshotListener();
    }
  }
}

export default NetworkDetector(App);
